import { withSvgIcon } from './withSvgIcon';

export const Send = withSvgIcon(
  <path
    d="M10 14L2 10L22 2L14 22L10 14ZM10 14L14 10"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
